<template>
  <div class="send bar-content">
    <Nav :calculate="false" />
    <h1 v-show="pageRoute('sendpackge')" class="title">Please complete your send shipping</h1>
    <h1 v-show="pageRoute('receivepackge')" class="title">Please complete your return shipping</h1>
    <div v-if="pageRoute('prepayment') || pageRoute('receive-pay')" class="alert-container">
      <i-alert type="warning" show-icon>
        Shipping label created! Please pay the bill within
        <b><Countdown :seconds-remaining="secondsRemaining" @on-end="countdownEnd"/></b>
        as soon as possible. It will be automatically canceled if expired.
      </i-alert>
    </div>
    <div class="send-container">
      <div v-if="showPaymentFailed" class="top-message">
        <i-alert type="error" show-icon class="alert">
          Payment failed
          <template v-slot:desc>
            Your payment method may be encountered an issue. Please confirm and change it promptly
          </template>
          <MoveButton class="button" @click="pushToPaymentFailed">Change</MoveButton>
        </i-alert>
      </div>
      <div class="send-info">
        <Login
          v-if="pageRoute('login')"
          title="Please login your account for so that you can access your orders and track packages status at any time"
          @register="curRoute = 'register'"
          @login-success="loginSuccess"
          @change-loading="changeLoading"
        />
        <Register
          v-if="pageRoute('register')"
          title="Please login your account for so that you can access your orders and track packages status at any time"
          @login="curRoute = 'login'"
          @register-success="registerSuccess"
          @change-loading="changeLoading"
          @login-success="loginSuccess"
        />
        <!--        <BindCard v-if="pageRoute('bindcard')" @change-loading="changeLoading" @bind-success="bindCardSuccess" />-->
        <PrePayment
          v-if="pageRoute('prepayment')"
          ref="prepayment"
          @change-loading="changeLoading"
          @bind-success="bindCardSuccess"
          @init-countdown="initCountdown"
          @change-route="changeRoute"
        />
        <BindEmail v-if="pageRoute('bindemail')" @change-loading="changeLoading" @bind-success="bindEmailSuccess" />
        <SendPackge
          v-show="pageRoute('sendpackge')"
          ref="sendpackge"
          @change-loading="changeLoading"
          @change-route="changeRoute"
        />
        <ReceivePackge
          v-if="pageRoute('receivepackge')"
          :box-num="boxNum"
          :trk-num="trkNum"
          :back-id="backId"
          @change-loading="changeLoading"
          @change-route="changeRoute"
          @change-back-id="backId = $event"
        />
        <ReceivePay
          v-if="pageRoute('receive-pay')"
          ref="receivePay"
          :back-id="backId"
          @change-loading="changeLoading"
          @change-route="changeRoute"
          @init-countdown="initCountdown"
          @change-payment-failed="changePaymentFailed"
        />
        <BoxStatus
          v-if="pageRoute('boxstatus')"
          @change-loading="changeLoading"
          @push-to-receive-pay="pushToReceivePay"
          @scheduleReturn="scheduleReturn"
          @change-payment-failed="changePaymentFailed"
        />
        <OrderPlaced v-if="pageRoute('orderPlaced')" @change-loading="changeLoading" @scheduleReturn="scheduleReturn" />
      </div>
      <div class="receive-warehouse">
        <KiteHouse v-if="kitehouse" :cur-route="curRoute" :back-id="backId" @change-route="changeRoute" />
      </div>
    </div>
    <i-spin v-if="loading || bindFedexLoading" fix>
      <i-icon type="ios-loading" size="40" class="spin-icon-load" />
    </i-spin>
  </div>
</template>

<script>
import Nav from '../../components/comm/Nav';
import Login from '../login/Login';
import Register from '../register/Register';
import BindCard from './components/BindCard';
import BindEmail from './components/BindEmail';
import SendPackge from './components/SendPackge';
import KiteHouse from './components/KiteHouse';
import ReceivePackge from './components/ReceivePackge';
import BoxStatus from './components/BoxStatus';
import { mapActions, mapMutations, mapState } from 'vuex';
import PrePayment from '@/views/send/components/PrePayment.vue';
import ReceivePay from '@/views/send/components/ReceivePay.vue';
import OrderPlaced from '@/views/send/components/OrderPlaced.vue';
import MoveButton from '@/components/button/Button.vue';
import Countdown from '@/components/comm/Countdown.vue';
export default {
  components: {
    Countdown,
    MoveButton,
    OrderPlaced,
    ReceivePay,
    PrePayment,
    Nav,
    Login,
    Register,
    BindCard,
    BindEmail,
    SendPackge,
    KiteHouse,
    ReceivePackge,
    BoxStatus,
  },
  data() {
    return {
      curRoute: '',
      loading: true,
      boxNum: [],
      trkNum: [],
      backId: 0,
      kitehouse: false,
      showPaymentFailed: false,
      secondsRemaining: 0,
    };
  },
  computed: {
    ...mapState('send', ['bindFedexLoading']),
  },
  mounted() {
    window.scroll(0, 0);
    this.initParams();
  },
  methods: {
    initParams() {
      let { params } = this.$route;
      if (params['orderNumber'] && params['orderNumber'] !== 'new') {
        this.initOrder(params['orderNumber']);
      } else {
        this.loading = false;
        this.kitehouse = true;
        this.clearOrder();
        this.curRoute = 'sendpackge';
      }
    },
    initOrder(orderNumber) {
      let { query } = this.$route;
      (query.ordertype === 'draft' ? this.fetchOrderMainDraftInfo(orderNumber) : this.fetchOrderMainInfo(orderNumber))
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.kitehouse = true;
            if (query.ordertype === 'unsent') {
              this.curRoute = 'orderPlaced';
            } else {
              this.curRoute = 'boxstatus';
            }
          } else {
            if (res.response && (res.response.status === 401 || res.response.status === 402)) {
              this.$router.push({
                name: 'login',
                query: {
                  back: 1,
                },
              });
            } else if (res.code) {
              this.checkChangeRoute(res);
            } else {
              this.$Message.error({
                content: res.message,
                duration: 5,
              });
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    checkChangeRoute(res) {
      let order = res.data;
      this.kitehouse = true;
      if (res.code === 'kite.common.order.need-verify') {
        this.changeRoute('bindemail');
      } else if (res.code === 'kite.common.order.need-input-email') {
        this.changeRoute('bindemail');
      } else if (res.code === 'kite.common.order.need-bind') {
        this.changeRoute('prepayment');
      } else if (res.code === 'kite.common.order.need-prepay') {
        this.changeRoute('prepayment');
      } else if (res.code === 'kite.common.fedex.ship.failed') {
        this.changeRoute('boxstatus');
      } else if (res.code === 'kite.common.fedex.pick.create-failed') {
        this.changeRoute('boxstatus');
      } else if (res.code === 'kite.common.bbl.response-error') {
        this.changeRoute('sendpackge');
      } else if (order.status === 'DRAFT') {
        this.changeRoute('sendpackge');
      }
      this.setOrder(order);
    },
    pageRoute(route) {
      return this.curRoute === route;
    },
    changeRoute(route) {
      this.curRoute = route;
    },
    registerSuccess() {
      this.curRoute = 'login';
    },
    loginSuccess() {
      this.curRoute = 'sendpackge';
      this.$refs['sendpackge'].saveOrder();
    },
    bindCardSuccess() {
      this.fetchOrderMainInfo(this.$route.params.orderNumber).finally(() => {
        this.pushToUnsent();
        this.curRoute = 'orderPlaced';
      });
    },
    bindEmailSuccess() {
      this.curRoute = 'prepayment';
    },
    scheduleReturn(box) {
      this.backId = box.backId;
      this.boxNum = box.boxList.map(item => item.boxNum);
      this.trkNum = box.boxList.map(item => item.trkNum);
      this.curRoute = 'receivepackge';
    },
    changeLoading(loading) {
      this.loading = loading;
    },
    changePaymentFailed(flag) {
      this.showPaymentFailed = flag;
    },
    initCountdown(seconds) {
      this.secondsRemaining = seconds;
    },
    pushToUnsent() {
      this.$router.push(`/send/${this.$route.params.orderNumber}?ordertype=unsent`);
    },
    pushToPaymentFailed() {
      this.$router.push(`/failed-bill/${this.$route.params.orderNumber}`);
    },
    pushToReceivePay(backId) {
      this.backId = backId;
      this.changeRoute('receive-pay');
    },
    countdownEnd() {
      if (this.pageRoute('prepayment')) {
        this.$refs.prepayment.showExpiredDialog();
      } else if (this.pageRoute('receive-pay')) {
        this.$refs.receivePay.showExpiredDialog();
      }
    },
    ...mapActions('send', ['fetchOrderMainInfo', 'fetchOrderMainDraftInfo']),
    ...mapMutations('send', ['clearOrder', 'setOrder']),
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';
.titleModal {
  .font-regular;
  font-size: 16px;
  font-weight: 400;
  color: #262626;
  line-height: 19px;
}
.send {
  background-color: @app-bg-color;
  padding-bottom: 56px;
  position: relative;
  min-height: 100%;
  .title {
    margin: 27px auto 0;
    width: 1148px;
    padding: 0 30px;
    font-size: 20px;
    font-weight: 400;
    color: @app-black-color;
  }
  .alert-container {
    width: 1148px;
    margin: 27px auto 0;
  }
  .send-container {
    width: 1148px;
    background-color: #fff;
    margin: 27px auto 0;
    padding: 30px;
    height: 100%;
    &:after {
      content: ' ';
      display: block;
      clear: both;
    }
    .send-info {
      float: left;
      min-height: 600px;
      width: 508px;
    }
    .receive-warehouse {
      float: left;
      margin-left: 80px;
      width: 500px;
      height: 100%;
    }
  }
}
.top-message {
  @import '~@/assets/fonts/font.less';
  .alert {
    padding: 5px 0 7px 69px;
    margin-bottom: 30px;
    ::v-deep .ivu-alert-message {
      .font-bold;
      margin-bottom: 0;
      font-size: 14px;
      color: #f56c6c;
      height: 18px;
    }
    ::v-deep .ivu-alert-desc {
      font-size: 12px;
      color: #f56c6c;
      height: 18px;
    }
    .button {
      height: 30px;
      position: absolute;
      right: 9px;
      top: 9px;
    }
  }
}
</style>
